/* eslint-disable import/no-cycle */
import React from "react";

import moment from "moment";

import { Dialog, DropdownChangeParams } from "primereact";

import BackButtom from "../../../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../../../components/datagrid";
import TemplateInvoice from "../../../../../../components/template-invoice";
import Icons from "../../../../../../components/icons-helper";
import ButtonRound from "../../../../../../components/button-action";
import ButtonComponent from "../../../../../../components/button";
import {
  DropdownStyled,
  InputNativeStyled,
} from "../../../../../../components/form-factory/styled";
import ResumeFiscalNote from "../../../../../../components/resume";

import {
  CardWrapper,
  IframeStyled,
  Wrapper,
  ConfirmDialogStyled,
} from "./styles";
import { theme } from "../../../../../../styles/theme";
import { ContainerButtonActions } from "../../styles";

import {
  DocumentsModel,
  DocumentsResponseModel,
} from "../../../../../../../domain/models/documents";

import {
  documentType,
  statusEnum,
  toastUtils,
} from "../../../../../../../utils";
import { handleClickInfo } from "../../../../../../helpers";

import { makeRemoteSolicitation } from "../../../../../../../main/factories/usecases/solicitation/remote-solicitation-factory";
import { makeRemoteFiscalNote } from "../../../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";

import { InvoiceModel } from "../../../../../../../domain/models/invoice";
import { FilterModel } from "../../../../../../../domain/models/enum";
import { DeveloperProps } from "../../../../../../../domain/models/developer.model";

type PageProps = {
  list: DocumentsResponseModel | undefined;
  setParams: any;
  developer: DeveloperProps | undefined;
  loading?: boolean;
  handleReload: () => void;
};

export const formCurrency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

const DocumentsListDeveloper: React.FC<PageProps> = ({
  list,
  setParams,
  loading,
  handleReload,
  developer,
}) => {
  const [selectedDocument, setSelectedDocument] = React.useState<
    DocumentsModel | undefined
  >();
  const [visible, setVisible] = React.useState<DocumentsModel | undefined>();
  const [remove, setRemove] = React.useState<DocumentsModel | undefined>();
  const [view, setView] = React.useState<any | undefined>();
  const [filter, setFilter] = React.useState<any | undefined>();
  const [selectedinvoice, setSelectedInvoice] = React.useState<
    InvoiceModel | undefined
  >();

  const [shouldForcePage, setShouldForcePage] = React.useState<boolean>(false);

  const fields: ItemField[] = [
    {
      title: "Modalidade",
      key: "documentType",
      renderItem: (data: DocumentsModel) =>
      `${documentType.find((el) => el.ENUM === data.type)?.label} ${data?.fiscalNote?.hasRecurrence === true ? " - Recorrente" : ""}`,
    },
    {
      title: "Número",
      key: "nfseNumber",
      renderItem: (data: DocumentsModel) =>
        data?.fiscalNote?.nfseNumber || data?.invoice?.bankDigit,
    },
    {
      title: "Data",
      key: "issuedOn",
      renderItem: (data: DocumentsModel) =>
        moment(data?.issuedOn).format("DD/MM/YYYY"),
    },
    {
      title: "Tomador",
      key: "tomador",
      renderItem: (data: DocumentsModel) =>
        data?.fiscalNote?.taker?.socialReason || data?.invoice?.bankName,
    },
    {
      title: "Status",
      key: "status",
      renderItem: (data: DocumentsModel) =>
        statusEnum.find((el) => el.ENUM === data?.status)?.label,
    },
    {
      title: "Valor",
      key: "name",
      renderItem: (data: DocumentsModel) =>
        formCurrency.format(
          Number(data?.fiscalNote?.noteValue || data?.invoice?.total),
        ),
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data: DocumentsModel) => (
        <ContainerButtonActions>
          <ButtonRound
            title="Detalhes"
            backgroundColor={theme.colors.darkBlue}
            onClick={() => handleClickInfo(data)}
            color={theme.colors.blue100}
          >
            <Icons
              height={25}
              width={25}
              name="information"
              color={theme.colors.green}
            />
          </ButtonRound>
          <ButtonRound
            disabled={data?.fiscalNote?.status === "PENDING"}
            backgroundColor={theme.colors.darkBlue}
            onClick={async () => {
              if (data?.type === "INVOICE") {
                setSelectedInvoice({
                  ...data?.invoice,
                  serviceValue: String(data?.invoice?.total),
                  developerCompany: (data.invoice?.developerCompany as any)
                    ?.company,
                  currency:
                    `${data?.invoice?.currency?.name} - (${data?.invoice?.currency?.code}) - ${data?.invoice?.currency?.symbol} - ${data?.invoice?.currency?.id}` as any,
                });
              } else {
                const doc = await makeRemoteFiscalNote().preview({
                  id: data?.id,
                  type: "pdf",
                });
                const reader = new FileReader();
                reader.readAsDataURL(doc);
                reader.onload = () => {
                  setView({
                    doc: data,
                    pdf: reader.result
                      ?.toString()
                      .replace(
                        "data:application/octet-stream;base64",
                        "data:application/pdf;base64",
                      ),
                  });
                };
              }
            }}
            title="Vizualizar"
            color={theme.colors.green}
          >
            <Icons
              height={15}
              width={15}
              name="eye"
              color={theme.colors.green}
            />
          </ButtonRound>
          <ButtonRound
            disabled={data?.fiscalNote?.status === "PENDING"}
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              if (data?.type === "INVOICE") {
                setSelectedInvoice({
                  ...data?.invoice,
                  serviceValue: String(data?.invoice?.total),
                  developerCompany: (data.invoice?.developerCompany as any)
                    ?.company,
                  currency:
                    `${data?.invoice?.currency?.name} - (${data?.invoice?.currency?.code}) - ${data?.invoice?.currency?.symbol} - ${data?.invoice?.currency?.id}` as any,
                });
              } else {
                setView({ doc: data });
              }
            }}
            title="Resumo"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="download"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            disabled={data.status === "CANCELED"}
            onClick={() => {
              setRemove(data);
            }}
            title="Cancelar"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="close"
              color={theme.colors.red}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            disabled={data.status === "CANCELED"}
            onClick={() => {
              setRemove(data);
            }}
            title="Cancelar Recorrência"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="close"
              color={theme.colors.red}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));

    setShouldForcePage(false);
  };

  return (
    <Wrapper>
      <BackButtom text="Documentos Emitidos" />
      <CardWrapper>
        <div className="d-flex align-items-center">
          <div className="me-5">
            <b>Nome usuário:</b>
            <span>{` ${developer?.name}`}</span>
          </div>
          <div className="ms-4 d-flex align-items-center  flex-row">
            Filtrar por:
            <DropdownStyled
              name="filter"
              disabled={false}
              options={[
                { value: 0, label: "Todos" },
                { value: "FISCAL_NOTE", label: "Nota Fiscal" },
                { value: "INVOICE", label: "Invoice" },
              ]}
              placeholder="Tipo de documento"
              value={filter?.type}
              optionLabel="label"
              optionValue="value"
              style={{ marginBottom: 0, width: "250px", marginLeft: "10px" }}
              onChange={(e: DropdownChangeParams) => {
                setFilter((prev: any) => ({
                  ...prev,
                  type: e.target.value,
                }));

                setParams((prev: FilterModel) => ({
                  ...prev,
                  filters: { ...prev?.filters, type: e.target.value },
                  page: 0,
                }));

                setShouldForcePage(true);
              }}
            />
          </div>
          <div className="ms-5 d-flex align-items-center flex-column">
            Data início:
            <InputNativeStyled
              name="filter"
              disabled={false}
              type="date"
              placeholder="Data de Emissão"
              value={filter?.issuedOn}
              style={{ width: "150px", marginLeft: "0", marginBottom: "25px" }}
              onChange={(e: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  issuedOn: e.target.value,
                }));

                setParams((prev: FilterModel) => ({
                  ...prev,
                  filters: { ...prev?.filters, issuedOn: e.target.value },
                  page: 0,
                }));

                setShouldForcePage(true);
              }}
            />
          </div>
          <div className="ms-5 d-flex align-items-center flex-column">
            Data Fim:
            <InputNativeStyled
              name="filter"
              disabled={false}
              type="date"
              placeholder="Data de Emissão"
              value={filter?.issuedOff}
              style={{ marginBottom: 25, width: "150px", marginLeft: "0" }}
              onChange={(e: any) => {
                setFilter((prev: any) => ({
                  ...prev,
                  issuedOff: e.target.value,
                }));

                setParams((prev: FilterModel) => ({
                  ...prev,
                  filters: { ...prev?.filters, issuedOff: e.target.value },
                  page: 0,
                }));

                setShouldForcePage(true);
              }}
            />
          </div>
        </div>
      </CardWrapper>
      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={handlePage}
        shouldForcePage={shouldForcePage}
      />
      <Dialog
        header="Invoice:"
        visible={!!selectedinvoice}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        footer={null}
        onHide={() => setSelectedInvoice(undefined)}
      >
        <TemplateInvoice
          invoice={selectedinvoice}
          onCancelCallback={() => setSelectedInvoice(undefined)}
        />
      </Dialog>
      <ConfirmDialogStyled
        visible={!!visible}
        onHide={() => setVisible(undefined)}
        message="Você confirma a liberação do cadastro do usuário?"
        // header="Confirmation"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          try {
            await makeRemoteSolicitation().complete(visible?.id);
            handleReload();
            toastUtils.showMessage({
              type: "success",
              message: "Confirmado com Sucesso!",
            });
          } catch (error: any) {
            toastUtils.showMessage({
              type: "error",
              message: error?.userMessage || error?.detail,
            });
          }
        }}
        reject={() => setVisible(undefined)}
      />
      <ConfirmDialogStyled
        visible={!!remove}
        onHide={() => setRemove(undefined)}
        message="Você confirma o cancelamento desse documento?"
        // header="Confirmation"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          try {
            const response = await makeRemoteFiscalNote().cancel(remove?.id);

            handleReload();

            if (response.status === "PROCESSING") {
              toastUtils.showMessage({
                type: "warning",
                message:
                  "O cancelamento está em processamento e pode levar até 10 minutos para concluir!",
              });
            } else {
              toastUtils.showMessage({
                type: response.status === "FAILED" ? "error" : "success",
                message:
                  response.status === "FAILED"
                    ? "Houve um erro ao tentar cancelar a nota"
                    : "Nota cancelada com Sucesso!",
              });
            }
          } catch (error: any) {
            toastUtils.showMessage({
              type: "error",
              message: error?.userMessage || error?.detail,
            });
          }
        }}
        reject={() => setRemove(undefined)}
      />
      <Dialog
        header="Resumo da Nota Fiscal:"
        visible={!!selectedDocument}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        footer={null}
        onHide={() => setSelectedDocument(undefined)}
      >
        <ResumeFiscalNote fiscalNote={selectedDocument?.fiscalNote} />
      </Dialog>
      <Dialog
        visible={!!view}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        footer={null}
        onHide={() => setView(undefined)}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
      >
        <div>
          {view?.pdf && (
            <IframeStyled title="pdf" src={`${view?.pdf}#toolbar=0`} />
          )}
        </div>
        <div className="mt-4 d-flex">
          <div className="w-50">
            <ButtonComponent
              type="button"
              title="Download XML"
              icon="download"
              color={theme.colors.white}
              backgroundColor={theme.colors.blue400}
              onClick={async () => {
                await makeRemoteFiscalNote().exportNote({
                  id: view?.doc?.id,
                  type: "xml",
                });
              }}
            />
          </div>
          <div className="ms-2 w-50">
            <ButtonComponent
              type="button"
              title="Download PDF"
              icon="download"
              color={theme.colors.white}
              backgroundColor={theme.colors.blue400}
              onClick={async () => {
                await makeRemoteFiscalNote().exportNote({
                  id: view?.doc?.id,
                  type: "pdf",
                });
              }}
            />
          </div>
        </div>
      </Dialog>
    </Wrapper>
  );
};
export default DocumentsListDeveloper;
